import { FC } from "react";
import { styled } from "styled-components";

const EventRatingContainer = styled.div`
	display: flex;
	background-color: ${({ theme }) => theme.colors.palette.primary.main.base};
	color: ${({ theme }) => theme.colors.palette.primary.main.contrast};
	${({ theme }) => theme.borderRadius.medium};
	width: 32px;
	height: 32px;
	justify-content: center;
	align-items: center;
	padding: ${({ theme }) => theme.spacing(1.5)};
	font-weight: bold;
	font-size: 0.75rem;
`;
export const EventRating: FC<{ rating: number | null; className?: string }> = ({ rating, className }) => {
	if (!rating) {
		return null;
	}
	return <EventRatingContainer className={className}>{rating.toFixed(1)}</EventRatingContainer>;
};
